





















































import Vue from 'vue'

import { SizeSpec, ProductState } from '@/product/types'
import { captureException } from '@sentry/browser'

export default Vue.extend({
  computed: {
    sizesSpec(): SizeSpec[][] {
      return (this.$store.state as ProductState).productDetail.sku.mappedSizeSpecs as SizeSpec[][]
    },
    headers(): string[] {
      return this.sizesSpec?.map(item => item[0].part) || []
    },
    sizes(): string[] {
      return this.sizesSpec[0]?.map(item => item.size) || []
    }
  },
  methods: {
    getDisplayValue(item?: {from: number, to?: number}) {
      if (item) {
        return item.from === -1 ? '-'
          : this.getSizeRange(item.from, item.to)
      } else {
        captureException(new Error('Missing size spec'))
      }
    },
    getSizeRange(from: number, to?: number) {
      return `${from}${to && to !== from ? '~' + to : ''}`
    }
  }
})
